import { useBootstrapState } from '../../bootstrap/bootstrap-provider';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { FormButton } from '../../forms/integrated-form-components/form-button';
import { useWorkspacePanel } from '../../panels/hooks/use-workspace-panel';
import { useEventMetadataStore } from '../event-panel-form/event-metadata';
import { useSetEventPanelModal } from '../event-panel-modals';
import { useRefreshEventPanel } from '../refresh-event-panel';

export const ClearEventButton = () => {
    const eventId = useWorkspacePanel().linkedEntityId;
    const eventMetadataStore = useEventMetadataStore();
    const refreshEventPanel = useRefreshEventPanel();
    const eventPanelOptions = useBootstrapState().eventPanelOptions;
    const setEventPanelModal = useSetEventPanelModal();
    const agencyId = eventMetadataStore.state.metadata?.agencyId;
    const { clearEvent } = useEnabledFeatures();
    return clearEvent ? (
        <FormButton
            variant="outline"
            onClick={() => {
                if (eventId && eventPanelOptions && agencyId) {
                    setEventPanelModal({
                        type: 'CLEAR_EVENT',
                        props: {
                            eventId,
                            agencyId,
                            refreshEventPanel,
                            eventPanelOptions,
                        },
                    });
                }
            }}
        >
            Clear
        </FormButton>
    ) : (
        <></>
    );
};
